
























import { handleError } from "@/lib/utility/handleError";
import { IClearanceApproval } from "@/models/clearance-approval.entity";
import Vue from "vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import SideCard from "../utility/SideCard.vue";
import ClearanceApprovalDetail from "./ClearanceApprovalDetail.vue";

@Component({
  components: { SideCard, ClearanceApprovalDetail, LatestEntriesCardEmpty }
})
export default class ClearanceApprovalSideCard extends mixins(Vue) {
  @Prop()
  value!: IClearanceApproval;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  isLoading = false;

  async mounted() {
    try {
      this.isLoading = true;

      await this.value.fetch();
    } catch (error) {
      handleError(error);
      this.close();
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.$emit("close");
  }
}
